var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 118,
    viewBox: "0 0 119 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7999 60.6094H3.42993V106.999H19.7999V60.6094Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.91 42.5605H27.54V107.011H43.91V42.5605Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.61 28.2207H51.24V107.001H67.61V28.2207Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.26 56.1094H98.8899V107.009H115.26V56.1094Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4401 47.3594H75.0701V106.999H91.4401V47.3594Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 115.859H118.85",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61 49.0003C14.145 49.0003 16.2 46.9453 16.2 44.4103C16.2 41.8753 14.145 39.8203 11.61 39.8203C9.07503 39.8203 7.02002 41.8753 7.02002 44.4103C7.02002 46.9453 9.07503 49.0003 11.61 49.0003Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7199 24.2698C38.2549 24.2698 40.3099 22.2148 40.3099 19.6798C40.3099 17.1449 38.2549 15.0898 35.7199 15.0898C33.1849 15.0898 31.1299 17.1449 31.1299 19.6798C31.1299 22.2148 33.1849 24.2698 35.7199 24.2698Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4301 11.18C61.9651 11.18 64.0201 9.12499 64.0201 6.59C64.0201 4.05501 61.9651 2 59.4301 2C56.8951 2 54.8401 4.05501 54.8401 6.59C54.8401 9.12499 56.8951 11.18 59.4301 11.18Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2499 33.1995C85.7849 33.1995 87.8399 31.1445 87.8399 28.6095C87.8399 26.0745 85.7849 24.0195 83.2499 24.0195C80.7149 24.0195 78.6599 26.0745 78.6599 28.6095C78.6599 31.1445 80.7149 33.1995 83.2499 33.1995Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.07 44.4105C109.605 44.4105 111.66 42.3555 111.66 39.8205C111.66 37.2855 109.605 35.2305 107.07 35.2305C104.535 35.2305 102.48 37.2855 102.48 39.8205C102.48 42.3555 104.535 44.4105 107.07 44.4105Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.24 41.6095L32.2 24.0195",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3101 17.29C40.7101 17.29 54.8301 9.5 54.8301 9.5",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3 9.03906L80.14 25.2391",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1299 31.0508L103.69 36.7308",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.506086f0.svg";
export { ForwardRef as ReactComponent };